module.exports = __webpack_public_path__ + "img/facebook-icon.31b5b77c.svg";